import React from 'react';
import { Row, Col, Typography, Button, Space, Divider } from 'antd';
import { MobileOutlined, AppleOutlined, AndroidOutlined, DesktopOutlined, TabletOutlined } from '@ant-design/icons';
import { useTheme } from 'hooks/useTheme';
import { useI18n } from 'hooks/useI18n';
import './MobileWarning.scss';

const { Title, Text, Paragraph } = Typography;

const MobileWarning = () => {
	const { theme, themeColor } = useTheme();
	const { t } = useI18n();

	return (
		<div className={`mobile-warning-container ${theme}-theme`}>
			<div className="mobile-warning-content">
				<Row justify="center" style={{ width: '100%', padding: '20px' }}>
					<Col xs={24} sm={22} md={20} lg={16} xl={14}>
						<div className="warning-card">
							{/* Animated Icon */}
							<div className="icon-container">
								<div className="animated-icon-wrapper">
									<DesktopOutlined className="desktop-icon" style={{ color: themeColor }} />
									<div className="device-divider" />
									<div className="mobile-icons">
										<MobileOutlined className="device-icon" />
										<TabletOutlined className="device-icon" />
									</div>
								</div>
							</div>

							{/* Logo */}
							<div className="logo-section">
								<img
									src={require('../../assets/images/logo.png')}
									alt="FITTE Logo"
									className="logo-image"
								/>
							</div>

							{/* Title & Message */}
							<div className="message-section">
								<Title level={2} className="warning-title">
									{t('mobile_warning.title')}
								</Title>
								
								<Paragraph className="warning-subtitle">
									{t('mobile_warning.subtitle')}
								</Paragraph>

								<div className="info-box">
									<DesktopOutlined style={{ fontSize: '24px', color: themeColor }} />
									<Text className="info-text">
										{t('mobile_warning.info_message')}
									</Text>
								</div>
							</div>

							<Divider className="section-divider">
								<Text className="divider-text">{t('mobile_warning.divider_text')}</Text>
							</Divider>

							{/* Mobile App Section */}
							<div className="mobile-app-section">
								<Title level={4} className="section-title">
									<MobileOutlined /> {t('mobile_warning.section_title')}
								</Title>
								
								<Paragraph className="app-description">
									{t('mobile_warning.app_description')}
								</Paragraph>

								<Space direction="vertical" size="large" style={{ width: '100%', marginTop: '24px' }}>
									{/* iOS Button */}
									<a 
										href="https://apps.apple.com/in/app/fitte-admin/id6737801521" 
										target="_blank" 
										rel="noopener noreferrer"
										style={{ display: 'block', width: '100%' }}
									>
										<Button
											type="primary"
											size="large"
											block
											icon={<AppleOutlined style={{ fontSize: '24px' }} />}
											className="app-button ios-button"
											style={{
												background: '#000000',
												borderColor: '#000000',
												height: '60px',
												borderRadius: '12px',
												display: 'flex',
												alignItems: 'center',
												justifyContent: 'center',
												gap: '12px',
											}}>
											<div style={{ textAlign: 'left' }}>
												<div style={{ fontSize: '11px', opacity: 0.8 }}>Download on the</div>
												<div style={{ fontSize: '18px', fontWeight: '600' }}>App Store</div>
											</div>
										</Button>
									</a>

									{/* Android Button */}
									{/* <a 
										href="https://play.google.com/store/apps/details?id=com.fitte.admin" 
										target="_blank" 
										rel="noopener noreferrer"
										style={{ display: 'block', width: '100%' }}
									>
										<Button
											type="primary"
											size="large"
											block
											icon={<AndroidOutlined style={{ fontSize: '24px' }} />}
											className="app-button android-button"
											style={{
												background: '#34A853',
												borderColor: '#34A853',
												height: '60px',
												borderRadius: '12px',
												display: 'flex',
												alignItems: 'center',
												justifyContent: 'center',
												gap: '12px',
											}}>
											<div style={{ textAlign: 'left' }}>
												<div style={{ fontSize: '11px', opacity: 0.8 }}>GET IT ON</div>
												<div style={{ fontSize: '18px', fontWeight: '600' }}>Google Play</div>
											</div>
										</Button>
									</a> */}
								</Space>
							</div>

							{/* Footer */}
							<div className="footer-section">
								<Text className="footer-text">
									{t('mobile_warning.support_text')}
								</Text>
								<Text className="footer-email" style={{ color: themeColor }}>
									{t('mobile_warning.support_email')}
								</Text>
							</div>
						</div>
					</Col>
				</Row>
			</div>
		</div>
	);
};

export default MobileWarning;
